import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, ViewChild, SecurityContext, HostBinding, EventEmitter, Output, Input } from "@angular/core";
import { MatCheckboxChange, MatSlider } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject, Subscription } from "rxjs";
import { ArticleCardOptions, ISelectItem, NewsletterCheckboxComponent } from "../../directives";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { ItemTagHelperService } from "../../services/itemTagHelper.service";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";
import { UserHelperService } from "../../services/userHelper.service";
import { WebShopService } from "../../services/webShop.service";
import { WebShopMode } from "../../services/IWebShopService";
import { ItemTagStatusType, ItemTagType, SortDirection, VoucherServiceType } from "../../shared/contentTypes";
import DateManager from "../../shared/dateManager";
import { DeliveryCountry, BasketLocationViewModel, ItemTagViewModel, ServiceOpenTimeViewModel, ScheduledForRequest, OrdertypeLocationSettings, DDLViewModel, LeadTimeType } from "../../shared/models";
import { SortOption } from "../../shared/models/sort.model";
import { PagingHelper } from "../../shared/pagingHelper";
import Utils from "../../shared/utils";
import { BasketService } from "../basket/basket.service";
import { LocationService } from "../location/location.service";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { MenuService } from "../menu/menu.service";
import { TermService } from "../term/term.service";
import { IBasketLocation, IDaySlot, ITimeSlot, IDeliveryCountry, IBasketItem, ITableSeat, IMenuCourse, ITableUI, ITableSeatItem } from "./basket.facade";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { DiscardBasketDialogComponent, LocationImpressumDialogComponent, TimeControlDialogComponent } from "../../modalDialogs";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { SnackBarService } from "../../services/snackBar.service";
import { IProductViewModel } from "../../shared/models/product.facade";
import * as moment from "moment";
import { orderTypes } from "../../shared/contentTypes";
import { MatCheckbox } from '@angular/material';
import { take, takeUntil } from "rxjs/operators";
import { EventmanagerService } from "../../services/eventmanager.service";
import { OrderTimeValidationService } from "../../services/orderTimeValidation.service";
import { TimeValidationResult, TimeSelectionStatus, INavigationOptions } from "../../services/IOrderTimeValidation.service";
import { NavigationRoute } from "../../shared/enums/navigation-route.enum";
import { AppErrorCode } from "../../shared/enums/ErrorCodes.enum";

@Component({
  selector: "ya-basket",
  templateUrl: "./basket.component.html",
  styleUrls: ["./basket.component.scss"],
  providers: [OverlaySpinnerService, BasketService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [],
})
export class BasketComponent implements OnInit, OnDestroy {
  @HostBinding("class") class = "ya-typography mat-tab-group";
  @Output() onContinue = new EventEmitter<{ to_group_basket: boolean }>(); // TODO Momentan nur um vorherige Funktionalität zu erhalten.
  @Output() basketDataChange = new EventEmitter<string>();
  @Input() isSingleTab: boolean = false;

  @ViewChild("tipSlider", { read: MatSlider }) tipSlider: MatSlider;
  @ViewChild("newsletterCheckbox") newsletterCheckbox: NewsletterCheckboxComponent;

  // New Variables;
  public basketData: string;
  private _DigipagerText: string = "";
  public location$: Observable<IBasketLocation>;
  public selectedDay$: Observable<IDaySlot>;
  public daySlots$: Observable<IDaySlot[]>;
  public selectedTime$: Observable<ITimeSlot>;
  public timeSlots$: Observable<ITimeSlot[]>;
  public selectedDeliveryCountry$: Observable<IDeliveryCountry>;
  public deliveryCountries$: Observable<IDeliveryCountry[]>;
  public menucourses$: Observable<IMenuCourse[]>;
  public basketItems$: Observable<IBasketItem[]>;
  public showTippingSlider: boolean;
  public tippingPercent$: Observable<number>;
  public tippingAmount$: Observable<number>;
  public deliveryFee$: Observable<number>;
  public totalSum$: Observable<number>;
  public showMinimumDeliveryValue$: Observable<boolean>;
  public minimumDeliveryValue$: Observable<number>;
  public showFreeShippingNotice$: Observable<boolean>;
  public hasAGBaccepted$: Observable<boolean>;
  public canContinue$: Observable<boolean>;
  public recommendationProducts$: Observable<IProductViewModel[]>;
  public tableSeats$: Observable<ITableSeat[]>;
  public table$: Observable<ITableUI>;

  get hasTimeSelection(): boolean {
    return this._basketService.hasTimeSelection;
  }

  //OLD
  public WebShopMode = WebShopMode;
  public isSmallView: boolean = false;
  public password: string;
  public currentLocation: number;
  public serviceOpenTimeViewModels: ServiceOpenTimeViewModel[];
  public locationOpenDays: DDLViewModel[] = null;
  public selectedServiceTime: string;
  private selectedOpenDay: IDaySlot;
  public commentVisibleInitilize: boolean = true;
  public matGroupSelectedIndex: number = 0;
  public isRegistered: boolean = false;
  public trinkgeldSliderValue: number;
  public trinkgeldInputValue: string;
  public serviceId: number;
  public minimumDeliveryValue: string = "";
  public currencySymbol: string = "";
  public deliveryCountries: DeliveryCountry[];
  public canTip$: Observable<boolean>;
  public useRedeemCoupon$: Observable<boolean>;
  public hasScheduledItems$: Observable<boolean>;

  private menucoursesSubscriber: Subscription;
  private langSubscriber: Subscription;
  private shippingCartSubscriber: Subscription;
  public recommendationProducts: IProductViewModel[];

  public likeIds: number[];
  public itemTags: ItemTagViewModel[];
  public isItemTagEnabled: boolean = true;
  public itemTagType: ItemTagType = ItemTagType.Text;
  public ArticleCardConfig: ArticleCardOptions;
  private sortOption: SortOption[];
  private pagingHelper: PagingHelper;
  public basketLocation: BasketLocationViewModel;
  public digipagerData: OrdertypeLocationSettings;
  public selectedDeliveryCountry: DeliveryCountry;

  private _destroy$ = new Subject<void>();

  public get orderASAP(): boolean {
    return this._webShopService.orderASAP;
  }

  public get hasAcceptedAGB(): boolean {
    return this._basketService.hasAcceptedAGB;
  }

  public set hasAcceptedAGB(accepted: boolean) {
    this._basketService.hasAcceptedAGB = accepted;
    this.PushChanges();
  }

  public AGB_innerhtml: any = "";
  @ViewChild('a11y_checkbox') checkboxRef: MatCheckbox;
  public a11y_Checkbox = {
    role: 'checkbox',
    tabindex: '0',
    aria_label: 'Checkbox'
  };

  public isTableOverviewExpanded: boolean = false;
  private _isContinuePending: boolean = false;
  private _isInitializing: boolean = false;

  constructor(
    private _webShopService: WebShopService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _locationService: LocationService
    , private _coreLogService: CoreLogService
    , private _basketService: BasketService
    , private _userHelperService: UserHelperService
    , private _internationalisationService: InternationalisationService
    , private _coreLanguageService: CoreLanguageService
    , private _iosHelperService: IOSHelperService
    , private _domSanitizer: DomSanitizer
    , private _menuService: MenuService
    , private _itemTagHelperService: ItemTagHelperService
    , private _termService: TermService
    , private _activatedRoute: ActivatedRoute
    , private _router: Router
    , private _inHouseOrderService: InHouseOrderService
    , private _eventManagerService: EventmanagerService
    , private _timeValidationService: OrderTimeValidationService
    , _mainnavService: MainnavService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _snackBarService: SnackBarService
  ) {
    const me = this;
    me.isSmallView = _mainnavService.viewType === ViewType.Small;
    me.setTermAcceptance();
  }

  ngOnInit() {
    const me = this;
    me.menucourses$ = me._basketService.menucourses$;
    me.basketItems$ = me._basketService.basketItems$;
    me.tableSeats$ = me._basketService.tableSeats$;
    me.table$ = me._basketService.table$;
    me.canTip$ = me._basketService.canTip$;
    me.useRedeemCoupon$ = me._basketService.useRedeemCoupon$;
    me.hasScheduledItems$ = me._basketService.hasScheduledItems$;
    me.basketData = 'Daten aus dem Warenkorb';
    me.basketDataChange.emit(me.basketData);

    me.pagingHelper = new PagingHelper();
    setTimeout(() => {
      if (me.tipSlider) {
        me.tipSlider._onClick = (e) => e.preventDefault();
      }
    }, 700);
    me.initialShippingCartData().then(async () => {
      me.PushChanges();
      if (me._webShopService.isTimeRequired) {
        const canContinue = await me.processSelectedServiceTime();
        if (!canContinue) {
          return;
        }
      }
      await me._openScheduleItemTimeControlDialog();
    }).catch(error => {
      me._coreLogService.error("BasketComponent.ngOnInit", "initialShippingCartData failed", error);
    });
    me.isRegistered = me._userHelperService.IsRegistered;

    me.shippingCartSubscriber = me._webShopService.ShippingCartObserver.subscribe(() => {
      // update tipping values
      me._configureTipping();
      me.PushChanges();
    });

    me.langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.trinkgeldInputValue = me._webShopService.formatCurrency(me._webShopService.trinkgeldValue, false);
      me.setTermAcceptance();
      me.setServiceAvailableTimeList().then(() => {
        me.PushChanges();
      });
      me.PushChanges();
    });

    me.initializeEventPriceValidation();
    if (me.serviceId === WebShopMode.OrderToTable) {
      me._loadDigipagerTextForIHLocation();
    }
    // getServiceMode() is used here because me.serviceId is not populated yet at this point in ngOnInit.
    if (me._webShopService.getServiceMode() === WebShopMode.Retail) {
      me._subscribeToDeliveryCountryChanges();
    }

    setTimeout(() => {
      if (me.checkboxRef) {
        const nativeInput = me.checkboxRef._inputElement.nativeElement;
        nativeInput.setAttribute('role', me.a11y_Checkbox.role);
        nativeInput.setAttribute('tabindex', me.a11y_Checkbox.tabindex);
        const label = me.a11y_Checkbox.aria_label || 'Accept terms and conditions';
        nativeInput.setAttribute('aria-label', label);
      }
    });
  }

  ngOnDestroy(): void {
    const me = this;
    me._destroy$.next();
    me._destroy$.complete();
    if (me.menucoursesSubscriber) {
      me.menucoursesSubscriber.unsubscribe();
    }
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
    if (me.shippingCartSubscriber) {
      me.shippingCartSubscriber.unsubscribe();
    }
    me._destroy$.next();
    me._destroy$.complete();
  }

  /** Resyncs the dropdown whenever DestinationCountry changes, incl. the Retail self-heal path (resolveRetailDeliveryFeeOrThrow()). */
  private _subscribeToDeliveryCountryChanges(): void {
    const me = this;
    me._webShopService.orderDataCountryChanged$
      .pipe(takeUntil(me._destroy$))
      .subscribe(() => {
        me._resyncSelectedDeliveryCountry();
        me.PushChanges();
      });
  }

  /** Matches by id, not reference — a settings reload / self-heal can replace DestinationCountry with a new instance carrying the same id. */
  private _resyncSelectedDeliveryCountry(): void {
    const me = this;
    me.deliveryCountries = me._webShopService.getDeliveryCountries();
    const destination = me._webShopService.DestinationCountry;
    me.selectedDeliveryCountry = destination
      ? (me.deliveryCountries || []).find(country => country.id === destination.id) || null
      : null;
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("BasketComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  /** ngFor trackBy Functions */
  public trackBasketItemBy(item: IBasketItem) {
    return item.id;
  }
  public trackTableSeatBy(seat: ITableSeat) {
    return seat.id;
  }
  public trackTableSeatItemBy(item: ITableSeatItem) {
    return item.id;
  }

  public onShowTermsClick(event: any) {
    const target: HTMLElement = event.target;
    if (target.id) {
      const eleIdArray: string[] = target.id.split("-");
      if (eleIdArray.length === 2) {
        const termid: number = +(eleIdArray[eleIdArray.length - 1]);
        if (termid != null) {
          this.openTermModel(termid);
        }
      }
    }
    event.stopPropagation();
  }

  /** Open term model */
  public openTermModel(termId: number): void {
    const me = this;
    me._termService.openTermModel(termId);
  }

  /**Set AGB */
  private setTermAcceptance(): void {
    const me = this;
    // Get Data From Resolver Data
    const resolverData = me._activatedRoute.snapshot.data["settingsViewModel"];
    if (resolverData) {
      const settingsViewModel = resolverData["settingsViewModel"];
      me.AGB_innerhtml = settingsViewModel.register_term_text;
      me.AGB_innerhtml = me._domSanitizer.bypassSecurityTrustHtml(me.AGB_innerhtml);
    }
  }

  /**AGB event */
  public onAcceptAGBChange(event: MatCheckboxChange) {
    this.hasAcceptedAGB = event.checked;
    this.PushChanges();
  }

  public MapLocationOpenDaysToSelecet(): ISelectItem[] {
    const result: ISelectItem[] = [];
    this.locationOpenDays.forEach((openDay) => {
      result.push({
        label: openDay.key,
        selected: this.checkDateFromMomentString(openDay.value),
        select: () => {
          this.setRequestOrderDay(openDay.value, openDay.use_time);
        }
      });
    });
    return result;
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public get impressumModelData() {
    const me = this;
    return me.basketLocation;
  }

  public get DigipagerText() {
    const me = this;
    return me._DigipagerText;
  }

  public openLocationImpressumDialog() {
    const me = this;
    me._bottomSheetHelperService.open(
      LocationImpressumDialogComponent,
      {
        data: {
          impressumHtml: me._domSanitizer.bypassSecurityTrustHtml(me.impressumModelData.impressumHtml),
        },
      }
    );
  }

  // *****************Shipping cart*************************

  /** Check if the service is Delivery or TakeAway */
  private isDeliveryOrTakeawayMode(): boolean {
    return this.serviceId === WebShopMode.Delivery ||
      this.serviceId === WebShopMode.TakeAway;
  }

  public get canDisplayOrderTimeSelection(): boolean {
    const me = this;
    if (!me.hasTimeSelection) {
      return false;
    }
    // if submission time is selected, allow selecting service time.
    // Otherwise, display selected service time.
    const result = me.isDeliveryOrTakeawayMode() ? me._webShopService.useOrderSubmissionTime : true;
    return result;
  }

  public async setRequestServiceTimeOnChange(index: string) {
    const me = this;
    const serviceTime = me.serviceOpenTimeViewModels[+index];
    me.selectedServiceTime = serviceTime.value;
    me._webShopService.orderASAP = serviceTime.asap;
    me._webShopService.setServiceOrderTime(serviceTime.value);
    await me._openScheduleItemTimeControlDialog();
    me.PushChanges();
  }

  /** selected by user or next available time */
  private get _selectedDateTime() {
    const me = this;
    if (!me._webShopService.isTimeRequired) {
      return moment();
    }
    const time = me.selectedServiceTime
      || (me._webShopService.serviceOrderTime ? me._webShopService.serviceOrderTime.toString() : null);
    return moment(time);
  }

  private async setRequestOrderDay(value: string, use_time: boolean) {
    const me = this;
    me.selectedOpenDay = { label: value, selected: use_time };
    await me.setServiceAvailableTimeList();
  }

  /**check the day of the opendays dropdown to retrive the old value and select the correct option */
  public checkDateFromMomentString(date: string) {
    const me = this;
    const dateString = Utils.GetDateFromMomentString(date);
    const selectedDay = Utils.GetDateFromMomentString(me.selectedOpenDay.label);
    return dateString === selectedDay;
  }

  private async setServiceAvailableTimeList() {
    const me = this;
    me.selectedOpenDay ? me.serviceOpenTimeViewModels = await me._webShopService.getAvailableServiceTimes(me.selectedOpenDay.label, me.selectedOpenDay.selected) : [];
    if (me.serviceOpenTimeViewModels && me.serviceOpenTimeViewModels.length > 0) {
      //submission time is already selected
      if (me.isDeliveryOrTakeawayMode() && me._webShopService.useOrderSubmissionTime) {
        // select order time
        const submissionTime = moment(me._webShopService.orderSubmissionTime);
        let nextAvailableTime: moment.Moment = moment(0);
        if (me._webShopService.serviceLeadTimeType == LeadTimeType.Minute) {
          nextAvailableTime = submissionTime.add(me._webShopService.serviceLeadTime, "minutes");
        }
        const serviceTime = me.serviceOpenTimeViewModels.find(time =>
          moment(time.value).isAfter(nextAvailableTime)
        );
        if (serviceTime) {
          me.selectedServiceTime = serviceTime.value;
        } else {
          //Default to first available time
          me.selectedServiceTime = me.serviceOpenTimeViewModels[0].value;
          me._webShopService.orderASAP = me.serviceOpenTimeViewModels[0].asap;
        }
      } else {
        const timeExists = me.serviceOpenTimeViewModels.some(t =>
          t.value === me.selectedServiceTime && t.asap === me.orderASAP
        );
        if (timeExists && me.selectedServiceTime) {
          // Keep the currently selected time if it's still valid
          // No need to change selectedServiceTime as it's already set
        } else if (me._webShopService.serviceOrderTime) {
          // Try to restore from service if available
          me.selectedServiceTime = me._webShopService.serviceOrderTime.toString();
        } else {
          //Default to first available time only if no valid time exists
          me.selectedServiceTime = me.serviceOpenTimeViewModels[0].value;
          me._webShopService.orderASAP = me.serviceOpenTimeViewModels[0].asap;
        }
      }
      me._webShopService.setServiceOrderTime(me.selectedServiceTime);
      await me._openScheduleItemTimeControlDialog();
      me.PushChanges();
    }
  }

  /** scheduled request depending on selected date time */
  private async _getScheduleReq() {
    const me = this;
    const webshopSettings = await me._webShopService.getWebshopSettingsDataModel();
    const schedule_req = new ScheduledForRequest(me._selectedDateTime, me._webShopService.locationID, webshopSettings, me._coreLanguageService);
    me.PushChanges();
    return schedule_req;
  }

  private async _openScheduleItemTimeControlDialog(): Promise<boolean> {
    const me = this;
    if (me._isInitializing) {
      return false;
    }
    if (!me._selectedDateTime.isValid()) {
      return false;
    }
    const schedule_req = await me._getScheduleReq();
    const scheduledBasketItems = await me._basketService.getScheduledItems(schedule_req);
    if (scheduledBasketItems && scheduledBasketItems.length > 0) {
      const selectedTime = DateManager.GetHMSFromMoment(me._selectedDateTime);
      const selectedDay = me._selectedDateTime.day();
      const bottomSheetRef = me._bottomSheetHelperService.open(TimeControlDialogComponent, {
        data: {
          items: scheduledBasketItems,
          selectedDay: selectedDay,
          selectedTime: selectedTime,
          schedule_req: schedule_req
        },
      });
      bottomSheetRef.afterDismissed().pipe(take(1)).subscribe(
        async (result) => {
          try {
            if (result === "remove") {
              await me._basketService.removeScheduledItemsFromBasket(scheduledBasketItems);
            } else if (result === "changeTime") {
              const validationResult = await me._timeValidationService.handleNewTimeSelection(false);
              if (validationResult.status === TimeSelectionStatus.TimeUpdated) {
                me.selectedServiceTime = validationResult.time.value;
                me.PushChanges();
                await me._openScheduleItemTimeControlDialog();
              }
            }
          } catch (err) {
            me._coreLogService.error("BasketComponent._openScheduleItemTimeControlDialog", "dismiss handler failed", err);
          } finally {
            me._basketService.clearScheduledItemsFlag();
            me.PushChanges();
          }
        },
        (err) => {
          me._coreLogService.error("BasketComponent._openScheduleItemTimeControlDialog", "afterDismissed stream error", err);
        }
      );
      me.PushChanges();
      return true;
    }
    me.PushChanges();
    return false;
  }

  private initializeEventPriceValidation() {
    const me = this;
    const needEventValidation: boolean = me.serviceId !== WebShopMode.Webvoucher
      && me.serviceId !== WebShopMode.DeliveryGroup
      && me.serviceId !== WebShopMode.PickupGroup;
    if (needEventValidation) {
      // Initial validation  only recalc prices, no dialog
      me._webShopService.handleEventPE().then(() => {
        me.onEventPriceChanged();
        me.PushChanges();
      }).catch(error => {
        me._coreLogService.error("BasketComponent.initializeEventPriceValidation", "handleEventPE failed", error);
      });
    }
  }

  private onEventPriceChanged(): void {
    const me = this;
    const basketItemPriceChanged = me._webShopService.recalcServicePeInBasket();
    me._webShopService.peChanged$.pipe(take(1)).subscribe(hasPeChanged => {
      me._webShopService.isEventPeActive$.pipe(take(1)).subscribe(isEventPeActive => {
        const priceChangedToServicePe = hasPeChanged && !isEventPeActive;
        if (basketItemPriceChanged && priceChangedToServicePe) {
          me._eventManagerService.OpenPriceChangeDialog();
        } else {
          // priceChangedToEventPe only recalculates prices, no dialog
        }
      });
    });
    me.PushChanges();
  }

  public getServiceDayLabel() {
    const me = this;
    return `${me._coreLanguageService.value(me.serviceId === WebShopMode.Delivery ? "phWebshop_Delivery_Day_Label" : "phWebshop_Pickup_Day_Label")}: `;
  }

  public getServiceTimeLabel() {
    const me = this;
    return `${me._coreLanguageService.value(me.serviceId === WebShopMode.Delivery ? "phWebshop_Delivery_Time_Label" : "phWebshop_Pickup_Time_Label")}: `;
  }

  public getTableMemberLabel(tableSeat: ITableSeat) {
    const me = this;
    if (tableSeat.seat !== 0) {
      return `${me._coreLanguageService.value("phInHouseLocalBasket_User_Placement").replace("{place_no}", tableSeat.seat.toString())}`;
    } else {
      return `${me._coreLanguageService.value("phInHouse_Payment_No_Assignment")}`;
    }
  }

  public SetUserPlace(userPlace: number) {
    const me = this;
    return me._coreLanguageService.value("phInHouseLocalBasket_User_Place")
      .replace("{placeNo}", userPlace.toString());
  }

  public get serviceModeChargeWebvoucher(): boolean {
    const me = this;
    return me._webShopService.voucherServiceType === VoucherServiceType.Charge;
  }

  public selectDeliveryCountry(deliveryCountry: DeliveryCountry) {
    const me = this;
    me.selectedDeliveryCountry = deliveryCountry;
    me._webShopService.selectDeliveryCountry(deliveryCountry);
    me.minimumDeliveryValue = me._webShopService.formatCurrency(me._webShopService.minimumOrderValue);
    me.PushChanges();
  }

  public getDeliveryCountryName(deliveryCountry: DeliveryCountry): string {
    return deliveryCountry["country_" + InternationalisationService.locale];
  }

  public isNullOrUndefinedOrEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  /** Configures tipping slider and input field values */
  private _configureTipping(): void {
    const me = this;
    me.trinkgeldSliderValue = me._webShopService.trinkgeldPercentage;
    me.trinkgeldInputValue = me._webShopService.formatCurrency(me._webShopService.trinkgeldValue, false);
  }


  /** Configures currency symbol and minimum delivery value display */
  private _configureCurrency(): void {
    const me = this;
    const DEFAULT_CURRENCY = "€";
    me.currencySymbol = me._webShopService.currencySymbol ? me._webShopService.currencySymbol : DEFAULT_CURRENCY;
    me.minimumDeliveryValue = me._webShopService.formatCurrency(me._webShopService.minimumOrderValue);
  }

  private _loadDigipagerTextForIHLocation() {
    const me = this;
    me._webShopService.getWebshopSettingsDataModel().then((settings) => {
      const location = me._inHouseOrderService.TableData.location;
      if (location) {
        const ih_ordertype = settings.ordertypes.find((ordertype) => ordertype.id == orderTypes.inHouse);
        if (ih_ordertype) {
          const location_settings = ih_ordertype.location_settings.find((loc_settings) => loc_settings.location === location)
          if (location_settings) {
            me._DigipagerText = location_settings.digipager_optional_text;
            me.PushChanges();
          }
        } else {
          me._coreLogService.error("InHauseOrderConfirmComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel no ih_ordertype");
        }
      } else {
        me._coreLogService.error("InHauseOrderConfirmComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel no location");
      }
    }).catch((error) => {
      me._coreLogService.error("InHauseOrderConfirmComponent.ngOnInit", "_webShopService.getWebshopSettingsDataModel catch", error);
    });
  }

  /** Loads location details based on currentLocation ID */
  private async _loadLocation() {
    const me = this;
    try {
      const location = await me._locationService.GetWebshopLocationViewModelByID(me.currentLocation);
      if (!location || !Object.keys(location).length) {
        throw new Error(`Location with ID ${me.currentLocation} not found or empty`);
      }
      me.basketLocation = location;
      me.PushChanges();
    } catch (error) {
      const errorMessage = error.message || "Failed to load location details";
      me._coreLogService.error("locationService", errorMessage);
    }
  }

  /**
   * - Loads available delivery countries and selects default
   * - handles errors without blocking initialization
   */
  private async _loadDeliveryCountries(): Promise<void> {
    const me = this;
    try {
      me.deliveryCountries = me._webShopService.getDeliveryCountries();
      if (me.deliveryCountries && me.deliveryCountries.length !== 0) {
        const defaultCountryCode = me._basketService.getDefaultCountryCode(me.basketLocation.phone_no);
        const identifiedCountry = me.deliveryCountries.find((country) => {
          return country.country_de === defaultCountryCode;
        });
        const selectedCountry = identifiedCountry ? identifiedCountry : me.deliveryCountries[0];
        me.selectDeliveryCountry(selectedCountry);
      }
    } catch (error) {
      me._coreLogService.error("BasketComponent._loadDeliveryCountries", "Failed to load delivery countries", error);
    }
  }


  /**Sets up order time selection for delivery/takeaway services
   *
   * !Used only to keep the old functionality if the order time is not checked at the beginning.
   */
  private async _setupOrderTimeSelection(): Promise<void> {
    const me = this;
    me.locationOpenDays = [];
    me.selectedServiceTime = me._webShopService.serviceOrderTime ? me._webShopService.serviceOrderTime.toString() : "";
    try {
      const openDays = await me._webShopService.getOpenDays();
      // case: no open days available
      if (!openDays || openDays.length === 0) {
        await me.setServiceAvailableTimeList();
        me.PushChanges();
        return;
      }
      me.locationOpenDays = openDays;
      // Restore previously selected time or use first available
      if (me._webShopService.serviceOrderTime) {
        await me.setRequestOrderDay(me._webShopService.serviceOrderTime.toString(), false
        );
      } else {
        const firstDay = me.locationOpenDays[0];
        await me.setRequestOrderDay(firstDay.value, firstDay.use_time);
      }

    } catch (error) {
      me._coreLogService.error("BasketComponent._setupOrderTimeSelection", "Failed to setup order time selection", error);
      // Try fallback
      await me._handleSchedulingError();
    }
  }

  /** Loads item tags and recommendation products if enabled*/
  private async _loadItemTagsAndRecommendations() {
    const me = this;
    try {
      const settings = await me._webShopService.getWebshopSettingsDataModel();
      if (!settings || !settings.is_itemtag_enabled) {
        return;
      }
      me.itemTags = await me._itemTagHelperService.GetProductTags();
      if (!me.itemTags || me.itemTags.length <= 0) {
        return;
      }
      me.isItemTagEnabled = settings.is_itemtag_enabled;
      me.itemTagType = settings.itemtag_type;
      me.likeIds = me.itemTags.filter(t => t.itemTagStatus === ItemTagStatusType.like).map(m => m.id);
      const recommendationProductIDs = me._webShopService.recommendationProductIds;
      if (recommendationProductIDs && recommendationProductIDs.length > 0) {
        me.recommendationProducts = await me._menuService.GetProductsByProductIds(
          me.currentLocation,
          recommendationProductIDs,
          me.itemTags,
          me.likeIds
        );
      }
    } catch (error) {
      me._coreLogService.error("BasketComponent._loadItemTagsAndRecommendations", "Failed to load item tags and recommendations", error);
    }

  }

  /** Handles scheduling errors with fallback strategy */
  private async _handleSchedulingError(): Promise<void> {
    const me = this;
    try {
      await me.setServiceAvailableTimeList();
    } catch (error) {
      me._coreLogService.error("BasketComponent._handleSchedulingError", "Scheduling fallback failed", error);
    }
  }

  /** Initializes shipping cart data and configurations*/
  private async initialShippingCartData() {
    const me = this;
    me._isInitializing = true;
    try {
      // set basic service data
      me.serviceId = me._webShopService.getServiceMode();
      me.currentLocation = me._webShopService.locationID;
      // load required base data
      await me._loadLocation();
      await me._loadItemTagsAndRecommendations();
      await me._loadDeliveryCountries();
      // apply display values
      me._configureTipping();
      me._configureCurrency();
      // initialize service time selection
      me.initializeSelectedServiceTime();
      if (me.canDisplayOrderTimeSelection) {
        await me._setupOrderTimeSelection();
      }
      // setup UI behavior and configuration
      me.setRecommendationContainer();
      me.initializeSortAndFilterOption();
      me.setArticleCardConfig();
    } catch (error) {
      me._coreLogService.error("BasketComponent.initialShippingCartData", "data initialization failed", error);
    } finally {
      me._isInitializing = false;
    }
  }

  /**Initializes selected service time based on current state or cached value*/
  private initializeSelectedServiceTime(): void {
    const me = this;
    if (me._webShopService.isTimeRequired) {
      if (me._webShopService.serviceOrderTime === null) {
        // No time currently set, try to restore from cache
        me._webShopService.restoreAndSetServiceTimeFromCache()
          .then(() => {
            // Check if restoration was successful before setting selectedServiceTime
            if (me._webShopService.serviceOrderTime) {
              me.selectedServiceTime = me._webShopService.serviceOrderTime.toString();
            } else {
              me.selectedServiceTime = "";
            }
            me.PushChanges();
          })
          .catch((error) => {
            me._coreLogService.error("BasketComponent.initializeSelectedServiceTime", "Failed to restore service time from cache", error);
            me.selectedServiceTime = "";
            me.PushChanges();
          });
      } else {
        // Service order time is already set, use it directly
        me.selectedServiceTime = me._webShopService.serviceOrderTime.toString();
        me.PushChanges();
      }
    } else {
      // Time pre-selection is not enabled, clear any selected time
      me.selectedServiceTime = "";
    }
  }

  /** Refresh selected service time after external changes */
  public refreshSelectedServiceTime(): void {
    const me = this;
    me.initializeSelectedServiceTime();
  }

  private async processSelectedServiceTime() {
    const me = this;
    const navigationOptions: INavigationOptions = {
      navigateBeforeDialog: false,
      navigateOnClose: true
    }
    const result: TimeValidationResult = await me._timeValidationService.validateServiceTime(navigationOptions);
    if (result.status === TimeSelectionStatus.Valid) {
      return true; // no need to update time, continue.
    }
    if (result.status === TimeSelectionStatus.TimeUpdated) {
      me.selectedServiceTime = result.time.value;
      me._webShopService.handleEventPE().then(() => {
        me.onEventPriceChanged();
      }).catch(error => {
        me._coreLogService.error("BasketComponent.processSelectedServiceTime", "handleEventPE failed after time update", error);
      });
      me.PushChanges();
      return true; // new time accepted, caller continues with conflict check.
    }
    if (result.status === TimeSelectionStatus.None) {
      // No time selected - navigate to time selector
      await me._router.navigate([NavigationRoute.OrderTimeSelector]);
      return false;
    }
    return false; //Cancelled or ServiceUnavailable (dialog/navigation already handled).
  }

  public isShippingCartBtnActive(basketItems: IBasketItem[]): boolean {
    const me = this;
    // Check if time is selected when required (for Delivery/TakeAway)
    const timeIsValid = !me._webShopService.isTimeRequired || !!me.selectedServiceTime;
    // Services that require minimum price check
    const requiresMinPrice = [WebShopMode.Delivery, WebShopMode.Retail];
    const hasBasketItems = basketItems && basketItems.length > 0;
    const meetMinimumPrice = !requiresMinPrice.includes(me.serviceId) || me._webShopService.meetMinimomPrice;
    return timeIsValid
      && hasBasketItems
      && meetMinimumPrice
      && me.hasAcceptedAGB;
  }

  public navigateToCouponRedeem() {
    const me = this;
    me._router.navigate(["/couponRedeem"]);
  }

  public onSliderValueChange() {
    const me = this;
    const newPercentage = me.trinkgeldSliderValue;
    me._webShopService.setTrinkgeldPercentage(newPercentage);
    me.PushChanges();
  }

  public onInputTrinkgeldChange() {
    const me = this;
    const newAmount = +(me.trinkgeldInputValue.replace(",", "."));
    me._webShopService.setTrinkgeldAmount(newAmount);
    me.PushChanges();
  }

  public get deliveryFee(): number {
    return this._webShopService.deliveryFee;
  }

  public get finalDeliveryFee(): number {
    return this._webShopService.finalDeliveryFee;
  }

  public getBasketSumTotal(): number {
    return this._webShopService.getBasketSumTotal();
  }

  /** wird genutzt wenn bei InHouse geordert wird, ohne sofort zu zahlen. Aber der WebshopService bereits den default Tip berechnet hat. */
  public getBasketSumTotalWithoutTip(): number {
    return Utils.moneyRound(this._webShopService.getBasketSumTotal() - this._webShopService.trinkgeldValue);
  }

  /**
   * @returns Summe aller Produkte im Warenkorb
   */
  public getBasketSumOfProducts(): number {
    return Utils.moneyRound(this.getBasketSumTotalWithoutTip() - this.finalDeliveryFee);
  }

  public get meetMinimomPrice(): boolean {
    return this._webShopService.meetMinimomPrice;
  }

  public hasOnlyBenefitItems(basketItems: IBasketItem[]): boolean {
    const isBenefitItems = basketItems && basketItems.length > 0 && basketItems.every(item => item.isBenefit);
    return isBenefitItems && this.getBasketSumOfProducts() === 0;
  }

  /** Anzeigen vom Hinweis, dass der Betrag für freie Lieferung noch nicht erreicht wurde */
  public get showFreeShippingNotice(): boolean {
    return this._webShopService.useFreeShipping && this._webShopService.remainingAmountUntilFreeShipping > 0 && this.finalDeliveryFee > 0;
  }

  public getFreeShippingText(): string {
    const me = this;
    const remaingAmountUntilFreeShipping = me._webShopService.formatCurrency(me._webShopService.remainingAmountUntilFreeShipping);
    return me._coreLanguageService.value("phWebshop_FreeShippingAt_BASE")
      .replace("{amount}", remaingAmountUntilFreeShipping);
  }

  public formatCurrency(price: number): string {
    return this._webShopService.formatCurrency(price);
  }

  formatTipSliderLabel(value: number | null) {
    const me = this;
    if (!value || value === 0) {
      return 0 + " %";
    }
    return value + " %";
  }

  private setRecommendationContainer() {
    const me = this;
    setTimeout(() => {
      const recommendationContainer = document.getElementById("recommended-product");
      if (recommendationContainer) {
        const recommendationItems = Array.from(recommendationContainer.getElementsByClassName("item-column-container__item")) as HTMLElement[];
        if (recommendationItems && recommendationItems.length > 3) {
          recommendationContainer.style.height = `${recommendationItems[3].offsetTop - 8}px`;
          recommendationContainer.style.overflowY = "auto";
        }
      }
    }, 300);
  }

  /**set sorting option and filter at the first loading of the page */
  private initializeSortAndFilterOption() {
    const me = this;
    me.sortOption = [];
    if (me.isItemTagEnabled) {
      me.sortOption.push(me.pagingHelper.createSortOption("amountOfLikedTags", SortDirection.DESC));
    }
    if (me.recommendationProducts) {
      me.recommendationProducts.sort(me.pagingHelper.fieldSorter(me.sortOption));
    }
  }

  private setArticleCardConfig() {
    const me = this;
    const service = me._webShopService.getServiceMode();
    me.ArticleCardConfig = {
      checkAvailability: true,
      showPrice: true,
      allowAddingToBasket: (service !== WebShopMode.Viewing),
      allowViewingDetails: true,
    };
  }

  public canDisplaySelectedOrderTimeLabel(): boolean {
    const me = this;
    const isDeliveryOrTakeaway = me.serviceId === WebShopMode.Delivery || me.serviceId === WebShopMode.TakeAway;
    if (isDeliveryOrTakeaway) {
      return !me._webShopService.useOrderSubmissionTime;
    }
  }

  public loadOrderTimeLabel(selectedServiceTime: string): string {
    const me = this;
    // Return empty string if selectedServiceTime is not yet initialized
    if (!selectedServiceTime) {
      return "";
    }
    if (me.serviceId === WebShopMode.Delivery) {
      return me.setDeliveryTimeInfoLabel(selectedServiceTime);
    } else {
      return me.setPickupTimeInfoLabel(selectedServiceTime);
    }
  }

  /**Display delivery time info label */
  private setDeliveryTimeInfoLabel(selectedServiceTime: string) {
    const me = this;
    const day = me._displayDay(selectedServiceTime);
    const time = me._displayTime(selectedServiceTime);
    const isdayToday = me._isDayToday(selectedServiceTime);
    let deliveryTimeLabel = "";
    if (isdayToday) {

      if (me.orderASAP) {
        const timeLabel = me._coreLanguageService.value("phBasket_ServiceTime_ASAP_Today_Delivery")
          .replace("{time}", `<span class="emphasized">${time}</span>`);
        const asapText = me._coreLanguageService.value("phWebshop_AsSoonAsPossible");
        deliveryTimeLabel = me.getServiceTimeLabel() + asapText + " (" + timeLabel + ")";
      } else {
        deliveryTimeLabel = me._coreLanguageService.value("phBasket_ServiceTime_Today_Delivery")
          .replace("{time}", `<span class="emphasized">${time}</span>`);
      }
    } else {
      deliveryTimeLabel = me._coreLanguageService.value("phBasket_ServiceTime_Delivery")
        .replace("{day}", `<span class="emphasized">${day}</span>`)
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    }
    return deliveryTimeLabel;
  }

  /**Display pickup time info label */
  private setPickupTimeInfoLabel(selectedServiceTime: string) {
    const me = this;
    const day = me._displayDay(selectedServiceTime);
    const time = me._displayTime(selectedServiceTime);
    const isdayToday = me._isDayToday(selectedServiceTime);
    let deliveryTimeLabel = "";
    if (isdayToday) {
      if (me.orderASAP) {
        const timeLabel = me._coreLanguageService.value("phBasket_ServiceTime_ASAP_Today_Pickup").replace("{time}", `<span class="emphasized">${time}</span>`);
        const asapText = me._coreLanguageService.value("phWebshop_AsSoonAsPossible");
        deliveryTimeLabel = me.getServiceTimeLabel() + asapText + " (" + timeLabel + ")";
      } else {
        deliveryTimeLabel = me._coreLanguageService.value("phBasket_ServiceTime_Today_Pickup")
          .replace("{time}", `<span class="emphasized">${time}</span>`);
      }
    } else {
      deliveryTimeLabel = me._coreLanguageService.value("phBasket_ServiceTime_Pickup")
        .replace("{day}", `<span class="emphasized">${day}</span>`)
        .replace("{time}", `<span class="emphasized">${time}</span>`);
    }
    return deliveryTimeLabel;
  }


  /**  Formats the given dateTime string */
  private _displayTime(dateTime: string) {
    return moment(dateTime).format('HH:mm');
  }

  /** Formats the given date string */
  private _displayDay(date: string) {
    return moment(date).format('DD-MM-YYYY');
  }

  /** Check if selected day is today */
  private _isDayToday(selectedDay: string) {
    const today = moment().startOf('day');
    const isToday = moment(selectedDay).isSame(today, 'day');
    return isToday;
  }
  // ***************** End of Shipping cart*************************

  public get mandatoryPayment() {
    const me = this;
    return me._inHouseOrderService.TableData.mandatory_Payment;
  }

  public get canCheckIsSingleTab() {
    const me = this;
    return me.serviceId === WebShopMode.OrderToTable;
  }

  public get inHouseBtnLabel() {
    const me = this;
    const defaultcontinue = me._coreLanguageService.value("phInHouse_Continue_Btn");
    const orderNowWithCosts = me._coreLanguageService.value("phPayment_OrderNowWithCosts");
    return me.isSingleTab ? orderNowWithCosts : defaultcontinue;
  }

  public get showReturnToUrlBasketButton() {
    return !!this._webShopService.returnURLBasket;
  }

  public clearBasketItems() {
    const me = this;
    me.basketItems$.subscribe(items => {
      items.forEach(item => {
        item.discard();
      });
      // Hier kannst du auf die aktualisierten Daten zugreifen
      console.log('Basket Items nach der Aktualisierung:', items);
    });
  }

  /**
   * Ensures notification is set before order
   * Uses ensureNotificationIsSet from inHouseOrderService which handles Push and SMS notifications
   * If user cancels, shows dialog to discard basket or retry
   */
  private async askForNotification(): Promise<void> {
    const me = this;
    const isInHouseGroupOrder = false;

    const notificationSet = await me._inHouseOrderService.ensureNotificationIsSet(
      isInHouseGroupOrder,
      () => me._overlaySpinnerService.ShowLayoutSpinner(),
      () => me._overlaySpinnerService.HideLayoutSpinner()
    );
    if (!notificationSet) {
      me._snackBarService.ShowErrorMessageFailed(AppErrorCode.BASKET_SMS_NOTIFICATIONS_FAILED);
      // User cancelled notification setup - ask if basket should be discarded
      return new Promise<void>((resolve) => {
        const discardDialog = me._bottomSheetHelperService.open(DiscardBasketDialogComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: "mat-bottom-sheet-container-medium"
        });

        discardDialog.afterDismissed().subscribe(async (result) => {
          if (result === true) {
            // Discard basket and navigate back to landing page
            await me.clearBasketItems();
            me._inHouseOrderService.openInHauseLandingPage().then(/* do it async */).catch(/* ignore */);
            resolve();
          } else if (result === false) {
            // Try notification setup again
            await me.askForNotification();
            resolve();
          } else {
            // Just close dialog
            resolve();
          }
        });
      });
    }
    // Notification is set, continue with order
  }

  public navigateToUrlBasket(): void {
    const me = this;
    window.open(me._domSanitizer.sanitize(SecurityContext.URL, me._webShopService.returnURLBasket), "_self");
  }

  /** Validates required conditions and proceeds to checkout.*/
  public async continue(): Promise<void> {
    const me = this;
    if (me._isContinuePending) {
      return;
    }
    me._isContinuePending = true;
    try {
      if (me.serviceId === WebShopMode.OrderToTable) {
        await me.askForNotification();
      }
      if (me._webShopService.isTimeRequired) {
        const canContinue = await me.processSelectedServiceTime();
        if (!canContinue) {
          return;
        }
      }
      const hasConflicts = await me._openScheduleItemTimeControlDialog();
      if (hasConflicts) {
        return;
      }
      if (await me._basketService.continue) {
        me.onContinue.emit({ to_group_basket: false });
      }
    } finally {
      me._isContinuePending = false;
      me._changeDetectorRef.markForCheck();
    }
  }

}
